import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ProjectPage from "./pages/ProjectPage";
import SurveyPage from "./pages/SurveyPage";
import LoginPage from "./pages/LoginPage";

function AppHeader() {
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem("admin_token");

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    window.location.href = "/login";
  };

  return (
    <header style={{
      background: '#e8e8e8',
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 24px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <img 
          src="/logo-medaillon.png" 
          alt="Médaillon Conseils" 
          style={{ height: '32px', cursor: 'pointer' }} 
          onClick={() => navigate("/")}
        />
        <img src="/logo-opubliq.svg" alt="Opubliq" style={{ height: '32px' }} />
      </div>
      
      {isAuthenticated && (
        <button 
          onClick={handleLogout}
          style={{
            background: 'none',
            border: '1px solid #999',
            padding: '4px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Déconnexion
        </button>
      )}
    </header>
  );
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = !!localStorage.getItem("admin_token");
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <>
      <AppHeader />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/projects/:projectId" element={<ProtectedRoute><ProjectPage /></ProtectedRoute>} />
        <Route path="/projects/:projectId/surveys/:surveyId" element={<ProtectedRoute><SurveyPage /></ProtectedRoute>} />
      </Routes>
    </>
  );
}
